module.exports = __webpack_public_path__ + "img/constituent_compounds.35c2b1da.png";